import React from 'react'
import { Trans } from '@lingui/react/macro'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { AutoLoadMore } from '@newComponents/AutoLoadMore'
import { PresentationCard } from '@newComponents/Presentation/PresentationCard'

import { UserPresentationsScreenUpcomingPresentationsSection_user$key } from './__generated__/UserPresentationsScreenUpcomingPresentationsSection_user.graphql'

export const UserPresentationsScreenUpcomingPresentationsSection = ({
  user,
}: {
  user: UserPresentationsScreenUpcomingPresentationsSection_user$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenUpcomingPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations"
          ) {
          edges {
            node {
              ...PresentationCardNew_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.upcomingPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$color'>
          <Trans>Upcoming Presentations</Trans>
        </Strong>
        <Separator borderColor='$borderColor' />
      </XStack>

      {data.upcomingPresentations.edges.map((edge) => {
        return (
          <PresentationCard
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      <AutoLoadMore hasNext={hasNext} loadNext={loadNext} count={3} />
    </YStack>
  )
}
